import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Anchor from '../Link/Link';
import Button from '../Button/Button';
import Logo from '../../assets/logo.svg';


const Card = ({
  children,
  type,
  title,
  titleTag,
  titleId,
  linkType,
  text,
  url,
  linkText,
  linkLabel,
  target,
  icon,
  shadow,
  className,
  titleLink,
  ariaLabelledby,
}) => {

  const Element = titleTag || "h2";

  // ID attribute of title is optional, spread operator is used for rendering.
  let titleIdAttr = {};
  if (titleIdAttr) {
    titleIdAttr =  {id: titleId};
  }

  // aria-labelledby link attribute is optional, spread operator is used for rendering.
  let ariaLabelledbyAttr = {};
  if (titleIdAttr && ariaLabelledby) {
    ariaLabelledbyAttr = {[`aria-labelledby`]: titleId};
  }

  const link =
    linkType !== 'button' ? (
      <Anchor type="arrow" href={url} target={target} title={linkLabel} {...ariaLabelledbyAttr}>
        {linkText}
      </Anchor>
    ) : (
      <Button
        as="link"
        className={type !== 'orange' ? 'primary' : ''}
        target={target}
        href={url}
        title={linkLabel}
        {...ariaLabelledbyAttr}
      >
        {linkText}
      </Button>
    );

  return (
    <div className={cn('card', type, { shadow, 'large-padding': !!icon }, className)}>
      <div className={`title-wrapper ${titleTag}`}>

        {titleLink ? (
          <Anchor href={url} target={target} {...ariaLabelledbyAttr}>{
            icon && <img src={icon} alt={title} />}
            {title && <Element className="title" {...titleIdAttr}>{title}</Element>}
          </Anchor>)
          : (
            icon && <img src={icon} alt={title} /> ,
            title && <Element className="title" {...titleIdAttr}>{title}</Element>)
        }
      </div>
      {text && <p>{text}</p>}
      {children}
      {!(url ==='#') && link}
    </div>
  );
};

Card.defaultProps = {
  type: 'white',
  titleTag: 'h1',
  linkType: 'button',
  title: 'Inloggen met extra controle',
  text: '',
  url: '#',
  linkText: 'Link text',
  linkLabel: null,
  target: null,
  icon: false,
};

Card.propTypes = {
  type: PropTypes.oneOf(['orange', 'white', 'transparent', 'default', 'gray-border', 'orange-border', 'white show-for-large-up', 'white hide-for-large-up']),
  titleTag: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5']),
  linkType: PropTypes.oneOf(['button', 'anchor']),
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  url: PropTypes.string,
  linkText: PropTypes.string,
  linkLabel: PropTypes.string,
  target: PropTypes.string,
  icon: PropTypes.string,
};

export default Card;
